import React from "react";

export default function AuthLayoutWrapper({ children }) {
  return (
    <div
      className="bg-black relative flex min-h-screen w-full items-center justify-between bg-center bg-no-repeat p-6 md:p-12 lg:px-20"
      style={{
        backgroundImage: `url('/final-login-page.webp')`,
        backgroundSize: "100% 100%", // Fits the entire image to the screen without zooming or cropping
      }}
    >
      {/* Dark Overlay - Keeps the background image dimmer/darker for contrast */}
      <div className="bg-black/60 pointer-events-none absolute inset-0" />
      {/* Left Text Branding */}
      <div className="hidden max-w-lg rounded-lg bg-[#0000002e] px-[25px] py-[14px] text-white backdrop-blur-[1px] md:block">
        <h1 className="text-4xl font-extrabold leading-tight lg:text-5xl">
          One Platform. <br />
          <span>Unlimited Control.</span>
        </h1>
        <p className="mt-4 text-base font-normal text-gray-200">
          Manage exhibitors, visitors, schedule meetings – all from one place.
        </p>
      </div>

      {/* Right Side Outer Container */}
      <div className="relative my-auto flex h-[85vh] max-h-[700px] min-h-[580px] w-full max-w-[480px] items-center justify-center">
        {/* Orange Rotated Backdrop - Aligned to match Figma rotation & visible left edge */}
        <div
          className="absolute inset-0 h-full w-full rounded-[32px] opacity-100 transition-all"
          style={{
            transform: "rotate(-2.5deg) translate(12px, -2px)",
            transformOrigin: "bottom right",
            background:
              "linear-gradient(232.36deg, #FFFFFF 9.91%, var( --color-primary) 90.09%)",
          }}
        />

        {/* Main Front White Card */}
        <div className="relative flex h-full w-full flex-col justify-between overflow-y-auto rounded-[28px] bg-white p-8 shadow-2xl md:p-10">
          {/* Top Logo Section */}
          <div className="flex h-[6.25rem] w-full items-center justify-center">
            <img
              src="/loginlogo.png"
              alt="Logo"
              className="h-full w-auto object-contain"
            />
          </div>

          {/* Form Content */}
          <div className="flex flex-1 flex-col gap-5 pt-4">{children}</div>
        </div>
      </div>
    </div>
  );
}
